import React, { Component } from 'react';
export default class ContactUs extends Component {
  render() {
    return (
      <section id="contact">
          <div className="row section-head">
            <div className="ten columns">
              <p className="lead">
              Please contact me via email if you're interested in discussing any future opportunities or work.
              </p>
            </div>
          </div>
        </section>
        );
  }
}